angular.module('NiacsProjectApp.lms-filters', [
])
.filter('renderStudent',[function(){
    return function(student) {
        if(student) {
            return student.fullname + ' ('+student.mail+')';
        }
    };
}]);